import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { Toaster } from "./components/ui/sonner";
import { Homepage } from "./pages/Homepage";
import { Services } from "./pages/Services";
import { PergolaInstallation } from "./pages/PergolaInstallation";
import { MotorisedPergolas } from "./pages/MotorisedPergolas";
import { PergolaBlinds } from "./pages/PergolaBlinds";
import { GlassVerandas } from "./pages/GlassVerandas";
import { Projects } from "./pages/Projects";
import { Locations } from "./pages/Locations";
import { Contact } from "./pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/pergola-installation" element={<PergolaInstallation />} />
          <Route path="/services/motorised-pergolas" element={<MotorisedPergolas />} />
          <Route path="/services/pergola-blinds" element={<PergolaBlinds />} />
          <Route path="/services/glass-verandas" element={<GlassVerandas />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/locations" element={<Locations />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
